import React from "react";
import { makeStyles } from "@material-ui/styles";
import Modal from "@material-ui/core/Modal";
import Zmage from "react-zmage";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
const useStyles = makeStyles(theme => ({
  modal: {
    maxWidth: "80%",
    maxHeight: "90%",
    margin: "auto auto"
  },
  zmage: {
    margin: "auto auto",

    maxWidth: "100%",
    maxHeight: "100%"
  }
}));
function ImageModal(props) {
  const classes = useStyles();

  const { open, src, handleClose, width } = props;
  return (
    <Modal open={open} onClose={handleClose} className={classes.modal}>
      <Zmage
        src={src}
        alt=""
        backdrop="#333333"
        zIndex={100000}
        className={classes.zmage}
      />
    </Modal>
  );
}

export default ImageModal;
